import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('smarthomepanel');
    const { locale } = useRouter();

    return (
        <div className={`${css.aniFGsapA1} aniFGsapA1`}>
            <div className="msg-title">{t('smart_home_panel.thirteen_title')}</div>
            <div className="msg-line1">
                {t('smart_home_panel.thirteen_subtitle_pc1')}
                {['it'].includes(locale) && ` ${t('smart_home_panel.thirteen_subtitle_pc2')}`}
                <div className="word-wrap"></div>
                {!['it'].includes(locale) && t('smart_home_panel.thirteen_subtitle_pc2')}
            </div>
        </div>
    );
}
